export const OrderStatusKey = {
    WAIT_PAY: 'WAIT_PAY',
    WAIT_PAY_OVER_TIME: 'WAIT_PAY_OVER_TIME',
    COMPLETE: 'COMPLETE',
    CANCEL: 'CANCEL',
    UN_DELIVER: 'UN_DELIVER',
    DELIVER: 'DELIVER',
    RECEIVE: 'RECEIVE',
    INITIATE_REFUND: 'INITIATE_REFUND',

    REFUNDING: 'REFUNDING', // 发起退货
    RETURN_AGREE: 'RETURN_AGREE', //  同意
    RETURN_REFUSE: 'RETURN_REFUSE', // 拒绝
    REFUND_CONFIRM: 'REFUND_CONFIRM', // 已填写退款信息
    UN_REFUND_CONFIRM: 'UN_REFUND_CONFIRM' // 待填写退款信息

}
export const AfterSaleStatusEnum = {
    REFUNDING: 0,// 发起退货
    RETURN_AGREE: 1, //  同意
    RETURN_REFUSE: 2, // 拒绝
    REFUND_CONFIRM: 3,// 已填写退款信息
    UN_REFUND_CONFIRM: 4 // 待填写退款信息
}
export const OrderStatusLabelEnum = {
    WAIT_PAY: '待付款',
    WAIT_PAY_OVER_TIME: '超时',
    COMPLETE: '已完成',
    CANCEL: '已取消',
    UN_DELIVER: '待发货',
    DELIVER: '已发货',
    RECEIVE: '待评价',
    INITIATE_REFUND: '退款/售后',
    REFUNDING: '退款中',
    RETURN_AGREE: '已退款',
    RETURN_REFUSE: '拒绝退款'
}
export const serveType = {
    'systemUrl': 'systemUrl',
    'chatUrl': 'chatUrl',
    'ossUrl': 'ossUrl',
    'productUrl': 'productUrl',
    'orderUrl': 'orderUrl',
    'customer': 'customer',
    'qrCodeUrl': 'qrCodeUrl',
    'qrCodeUrlTest': 'qrCodeUrlTest'
};
const baseURL = {
    development: {
        [serveType.systemUrl]: 'https://test-api.mengshancms.com:9001/',// 系统服务
        [serveType.chatUrl]: 'https://test-api.mengshancms.com:9002/',// 聊天系统
        [serveType.productUrl]: 'https://test-api.mengshancms.com:9003/',// 商品
        [serveType.orderUrl]: 'https://test-api.mengshancms.com:9004/',// 订单
        [serveType.customer]: 'https://test-api.mengshancms.com:9005/',// 客户
        [serveType.ossUrl]: 'https://test-assets.mengshancms.com/',
        [serveType.qrCodeUrl]: 'https://test-api.mengshancms.com:9001/api/qrcode/user?userId=',
        [serveType.qrCodeUrlTest]: "https://test-api.mengshancms.com:9001/api/qrcode-test/user?userId="
    },
    pre: {
        [serveType.systemUrl]: 'https://test-api.mengshancms.com:9001/',// 系统服务
        [serveType.chatUrl]: 'https://test-api.mengshancms.com:9002/',// 聊天系统
        [serveType.productUrl]: 'https://test-api.mengshancms.com:9003/',// 商品
        [serveType.orderUrl]: 'https://test-api.mengshancms.com:9004/',// 订单
        [serveType.customer]: 'https://test-api.mengshancms.com:9005/',// 客户
        [serveType.ossUrl]: 'https://test-assets.mengshancms.com/',
        [serveType.qrCodeUrl]: 'https://test-api.mengshancms.com:9001/api/qrcode/user?userId=',
        [serveType.qrCodeUrlTest]: "https://test-api.mengshancms.com:9001/api/qrcode-test/user?userId="
    },
    prod: {
        [serveType.systemUrl]: 'https://api.mengshancms.com:9101/',// 系统服务
        [serveType.chatUrl]: 'https://api.mengshancms.com:9102/',// 聊天系统
        [serveType.productUrl]: 'https://api.mengshancms.com:9103/',// 商品
        [serveType.orderUrl]: 'https://api.mengshancms.com:9104/',// 订单
        [serveType.customer]: 'https://api.mengshancms.com:9105/',// 客户
        [serveType.ossUrl]: 'https://assets.mengshancms.com/',
        [serveType.qrCodeUrl]: 'https://api.mengshancms.com:9101/api/qrcode/user?userId=',
        [serveType.qrCodeUrlTest]: "https://api.mengshancms.com:9101/api/qrcode-test/user?userId="
    },
};
const env = baseURL[process.env.VUE_APP_ENV_NAME];
// const env = baseURL['prod'];
// export const MapKey = 'MQBBZ-JGXKG-UKDQW-Q7MVL-O4Q5V-AGFYD';
export const MapKey = 'VN4BZ-HYNCQ-WWD5Q-23CER-UYSLZ-2JBP5';
export const MenuCode = {
    "chat": "chat",//聊天消息,
    "chat-pub": "chat-pub",//聊天消息-发布公告,
    "chat-del": "chat-del",//聊天消息-删帖,
    "chat-ban": "chat-ban",//聊天消息-封禁,
    "admin": "admin",//企业客户,
    "admin-emp": "admin-emp",//企业客户-员工管理,
    "admin-emp-view": "admin-emp-view",//企业客户-员工管理-查看员工,
    "admin-emp-add": "admin-emp-add",//企业客户-员工管理-新增员工,
    "admin-emp-upd": "admin-emp-upd",//企业客户-员工管理-编辑员工,
    "admin-emp-del": "admin-emp-del",//企业客户-员工管理-删除员工,
    "admin-goods": "admin-goods",//企业客户-商品管理,
    "admin-goods-panel-view": "admin-goods-panel-view",//企业客户-商品管理-查看仪表盘,
    "admin-goods-view": "admin-goods-view",//企业客户-商品管理-查看商品,
    "admin-goods-add": "admin-goods-add",//企业客户-商品管理-新增商品,
    "admin-goods-upd": "admin-goods-upd",//企业客户-商品管理-编辑商品,
    "admin-goods-del": "admin-goods-del",//企业客户-商品管理-删除商品,
    "admin-goods-record": "admin-goods-record",//企业客户-商品管理-商品记录,
    "admin-draw": "admin-draw",//企业客户-抽奖管理,
    "admin-draw-view": "admin-draw-view",//企业客户-抽奖管理-查看抽奖,
    "admin-draw-add": "admin-draw-add",//企业客户-抽奖管理-新增抽奖,
    "admin-draw-upd": "admin-draw-upd",//企业客户-抽奖管理-编辑抽奖,
    "admin-draw-close": "admin-draw-close",//企业客户-抽奖管理-关闭抽奖,
    "admin-draw-del": "admin-draw-del",//企业客户-抽奖管理-删除抽奖,
    "admin-activity": "admin-activity",//企业客户-活动组织管理,
    "admin-activity-view": "admin-activity-view",//企业客户-活动组织管理-查看活动,
    "admin-activity-add": "admin-activity-add",//企业客户-活动组织管理-新增活动,
    "admin-activity-upd": "admin-activity-upd",//企业客户-活动组织管理-编辑活动,
    "admin-activity-del": "admin-activity-del",//企业客户-活动组织管理-删除活动,
    "admin-img": "admin-img",//企业客户-图片管理,
    "admin-img-view": "admin-img-view",//企业客户-图片管理-查看图片,
    "admin-img-upd": "admin-img-upd",//企业客户-图片管理-更新图片,
    "admin-auth": "admin-auth",//企业客户-权限管理,
    "admin-auth-view": "admin-auth-view",//企业客户-权限管理-查看权限,
    "admin-auth-add": "admin-auth-add",//企业客户-权限管理-新增权限,
    "admin-auth-upd": "admin-auth-upd",//企业客户-权限管理-编辑权限,
    "admin-auth-del": "admin-auth-del",//企业客户-权限管理-删除权限,
    "admin-pool": "admin-pool",//企业客户-公海池管理,
    "admin-pool-view": "admin-pool-view",//企业客户-公海池管理-查看公海池,
    "admin-pool-claim-cus": "admin-pool-claim-cus",//企业客户-公海池管理-认领客户,
    "admin-cus": "admin-cus",//企业客户-客户画像管理,
    "admin-cus-view": "admin-cus-view",//企业客户-客户画像管理-查看客户画像,
    "admin-cus-upd": "admin-cus-upd",//企业客户-客户画像管理-编辑客户画像,
    "admin-tag": "admin-tag",//企业客户-标签管理,
    "admin-tag-view": "admin-tag-view",//企业客户-标签管理-查看标签,
    "admin-tag-add": "admin-tag-add",//企业客户-标签管理-新增标签,
    "admin-tag-upd": "admin-tag-upd",//企业客户-标签管理-编辑标签,
    "admin-tag-del": "admin-tag-del",//企业客户-标签管理-删除标签,
    "admin-order": "admin-order",//企业客户-订单管理,
    "admin-order-view": "admin-order-view",//企业客户-订单管理-查看订单,
    "admin-order-upd": "admin-order-upd",//企业客户-订单管理-编辑订单,
    "admin_order_record": "admin_order_record",//企业客户-引流订单记录,
    "admin_platform_order_record": "admin_platform_order_record",//企业客户-平台订单记录,
    "general_view": "general_view",//总览,done
    "goods_count": "goods_count",//总览-商品销量统计,done
    "order_count": "order_count",//总览-引流订单记录,done
    "leader_driver": "leader_driver",//总览-平台引流订单记录,done
    "jkgw_order_count": "jkgw_order_count",//总览-健康顾问引流订单统计,done
    "kf_order_count": "kf_order_count",//总览-客服引流订单统计,done
    "system_manage": "system_manage",//系统管理,done
    "person_info": "person_info",//系统管理-个人资料,done
    "info_save": "info_save",//系统管理-个人资料-保存,
    "user": "user",//用户管理,done
    "user_ban": "user_ban",//用户管理-禁用启用,done
    "employee": "employee",//员工管理,done
    "employee_add": "employee_add",//员工管理-添加员工,done
    "leader": "leader",//员工管理-领导层,done
    "sale": "sale",//员工管理-销售部,done
    "operate": "operate",//员工管理-运营部,done
    "product": "product",//员工管理-生产部,done
    "customer_service": "customer_service",//员工管理-客服部,done
    "counselor": "counselor",//员工管理-顾问部,done
    "employee_export": "employee_export",//员工管理-员工导出,done
    "employee_update": "employee_update",//员工管理-员工编辑,done
    "employee_ban": "employee_ban",//员工管理-员工禁用,done
    "employee_delete": "employee_delete",
    "reset_password": "reset_password",
    "auth_manage": "auth_manage",//权限管理,done
    "role": "role",//权限管理-角色组, done
    "role_add": "role_add",//权限管理-角色组-添加角色,done
    "role_ban": "role_ban",//权限管理-角色组-停用角色,done
    "role_update": "role_update",//权限管理-label_mange-编辑角色,done
    "admin_mange": "admin_mange",//权限管理-管理员管理,done
    "admin_log": "admin_log",//权限管理-管理员日志,done
    "label_mange": "label_mange",//标签管理,done
    "label_add": "label_add",//标签管理-添加标签,done
    "label_update": "label_update",//标签管理-编辑标签,done
    "label_delete": "label_delete",//标签管理-删除标签,done
    "label_ban": "label_ban",//标签管理-禁用标签,done
    "goods_manage": "goods_manage",//商品管理, done
    "goods_repertory": "goods_repertory",//商品管理-商品库,  done
    "add_goods": "add_goods",//商品管理-商品库-添加商品,done
    "edit_inventory": "edit_inventory",//商品管理-商品库-编辑库存,done
    "get_goods": "get_goods",//商品管理-商品库-查看商品,done
    "edit_goods": "edit_goods",//商品管理-商品库-编辑商品,done
    "evaluate_manage": "evaluate_manage",//商品管理-评价管理,done
    "virtual_evaluate": "virtual_evaluate",//商品管理-评价管理-虚拟评价,done
    "show_evaluate": "show_evaluate",//商品管理-评价管理-显示状态,done
    "update_evaluate": "update_evaluate",//商品管理-评价管理-编辑评价,done
    "delete_evaluate": "delete_evaluate",//商品管理-评价管理-删除评价,done
    "service_guarantee": "service_guarantee",//商品管理-服务保障,
    "add_service": "add_service",//商品管理-服务保障-添加,
    "inventory_warn": "inventory_warn",//商品管理-库存预警,
    "replenishment_record": "replenishment_record",//商品管理-补货记录,done
    "order_center": "order_center",//订单中心,done
    "order_manage": "order_manage",//订单中心-订单管理,done
    "order_select": "order_select",//订单中心-订单管理-查询,done
    "order_export": "order_export",//订单中心-订单管理-订单导出,done
    "all_delivery": "all_delivery",//订单中心-订单管理-合并发货,done
    "all_order": "all_order",//订单中心-订单管理-全部订单,done
    "un_pay": "un_pay",//订单中心-订单管理-待付款,done
    "pre_delivery": "pre_delivery",//订单中心-订单管理-发货预审,done
    "delivery": "delivery",//订单中心-订单管理-已发货,done
    "un_evaluate": "un_evaluate",//订单中心-订单管理-待评价,done
    "refund": "refund",//订单中心-订单管理-退款/售后,done
    "delivery_now": "delivery_now",//订单中心-订单管理-立即发货,done
    "after_sale_manage": "after_sale_manage",//订单中心-售后管理,
    "add_after": "add_after",//订单中心-售后管理-添加售后,
    "edit_after": "edit_after",//订单中心-售后管理-编辑售后,
    "remove_after": "remove_after",//订单中心-售后管理-删除售后
    "pc_activity": "pc_activity",
    "pc_activity_add": "pc_activity_add",
    "pc_activity_edit": "pc_activity_edit",
    "pc_activity_delete": "pc_activity_delete",
    "pc_activity_select": "pc_activity_select",
    "pc_draw": "pc_draw",
    "pc_draw_add": "pc_draw_add",
    "pc_draw_edit": "pc_draw_edit",
    "pc_draw_delete": "pc_draw_delete",
    "total_order_count": "total_order_count",
}
export default env